import { capitalize } from './formats';

const transformClaim = (
  { loss: { date, cause, location }, ...remainingProps },
  extraData = {},
) => ({
  loss: {
    date,
    cause,
  },
  lossLocation: {
    street: location?.addressLine,
    city: location?.city,
    state: location?.state?.code,
    zip: location?.zipCode,
  },
  ...remainingProps,
  ...(extraData?.policyNumber && { policyNumber: extraData.policyNumber }),
  ...(extraData?.isFusion && { isFusion: extraData.isFusion }),
  ...(extraData?.type && { type: extraData.type }),
});

const transformClaims = (claims, extraData) =>
  claims.map((c) => transformClaim(c, extraData));

const transformPolicy = ({
  policyNumber,
  policyId,
  insuredStreet,
  insuredCity,
  insuredState,
  type,
  lineType,
  insuredZip,
  insuredFirstName,
  insuredLastName,
  insuredPhone,
  insuredEmail,
  effectiveDate,
  expirationDate,
  company,
  coapplicantFirstName,
  coapplicantLastName,
  coapplicantEmail,
  coapplicantPhone,
  propertyStreet,
  propertyApt,
  propertyCity,
  propertyState,
  propertyZip,
  status,
  policyPremium,
  coverages,
  additionalCoverages,
  deductibles,
  agentOrganizationName,
  agentFirstName,
  agentLastName,
  agentStreet,
  agentCity,
  agentState,
  agentZip,
  agentPhone,
  agentEmail,
  country,
  payment,
  cancellationReason,
  cancellationDate,
  billing,
  policySystem,
  fnol,
  organizationName,
}) => ({
  payment: payment || {},
  billing: billing || null,
  policySystem,
  country,
  policyNumber,
  policyId,
  status: status === 'InActive' ? 'Inactive' : status,
  statusCode: status === 'InActive' ? 'Inactive' : status,
  cancellationReason,
  cancellationDate,
  price: policyPremium,
  company,
  coapplicantFirstName,
  coapplicantLastName,
  coapplicantEmail,
  coapplicantPhone,
  type,
  lineType,
  isFusion: Boolean(lineType),
  effectiveDate,
  expirationDate,
  insured: {
    street: insuredStreet || '',
    city: insuredCity || '',
    state: insuredState || '',
    zip: insuredZip || '',
    firstName: insuredFirstName || '',
    lastName: insuredLastName || '',
    phone: insuredPhone || '',
    email: insuredEmail || '',
  },
  property: {
    street: propertyStreet ? capitalize(propertyStreet) : '',
    apt: propertyApt || '',
    city: propertyCity ? capitalize(propertyCity) : '',
    state: propertyState || '',
    zip: propertyZip || '',
  },
  agent: {
    organizationName: agentOrganizationName
      ? capitalize(agentOrganizationName)
      : '',
    firstName: agentFirstName || '',
    lastName: agentLastName || '',
    street: agentStreet ? capitalize(agentStreet) : '',
    city: agentCity ? capitalize(agentCity) : '',
    state: agentState || '',
    zip: agentZip || '',
    phone: agentPhone || '',
    email: agentEmail || '',
  },
  coverages:
    coverages && coverages.length > 0
      ? coverages.sort((a, b) => (a.title > b.title ? 1 : -1))
      : [],
  additionalCoverages: additionalCoverages || [],
  deductibles: deductibles || [],
  fnol: fnol || { data: {} },
  organizationName,
});

const transformEachPolicy = ({
  policyNumber,
  type,
  lineType,
  insuredFirstName,
  insuredLastName,
  insuredPhone,
  effectiveDate,
  expirationDate,
  propertyStreet,
  propertyApt,
  propertyCity,
  propertyState,
  propertyZip,
  propertyCountry,
  status,
  organization,
  organizationName,
}) => ({
  status,
  type,
  lineType,
  organization,
  organizationName,
  effectiveDate,
  expirationDate,
  policyHolderFirstName: insuredFirstName,
  policyHolderLastName: insuredLastName,
  policyHolderPhoneNumber: insuredPhone,
  policyNumber,
  propertyStreet,
  propertyApt,
  propertyCity,
  propertyState,
  propertyZip,
  propertyCountry,
  isFusion: Boolean(lineType),
});

const transformPolicies = (policies) =>
  policies.map((p) => transformEachPolicy(p));

export default {
  claims: transformClaims,
  policy: transformPolicy,
  policies: transformPolicies,
};
